// @flow
import React, { Component } from 'react';
import ContentHeader from 'app/common/react/ui/ContentHeader';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import { Box, Button, Container, Text, Avatar } from 'gestalt';

type Props = {|
  isOwnProfile?: boolean,
  showFixedHeaderName: ?boolean,
  showSignupModalWrapper: () => void,
  user: ProfileUser,
|};

class FixedHeader extends Component<Props> {
  header: ?HTMLElement = null;

  render() {
    const { showFixedHeaderName, user, showSignupModalWrapper } = this.props;
    const followText = i18n._('Follow', 'User follow button');

    return (
      <ContentHeader className="fixedHeader fixed" position="fixed">
        <Container>
          <Box
            alignItems="center"
            data-test-id="fixedProfileHeader"
            display="flex"
            marginTop={1}
            paddingY={2}
            width="100%"
            marginBottom={1}
            height="50"
          >
            <Box
              alignSelf="start"
              alignItems="center"
              display="flex"
              smDisplay="flex"
              padding={2}
              justifyContent="start"
              flex="grow"
            >
              <div
                className={cx('boardName', {
                  transitionIn: showFixedHeaderName,
                  transitionOut: showFixedHeaderName === false,
                })}
              >
                <Box display="flex" alignItems="center">
                  <Box display="inlineBlock">
                    <Avatar size="sm" name={user.full_name} src={user.image_xlarge_url} />
                  </Box>
                  <Box display="inlineBlock" paddingX={2}>
                    <Text align="center" inline bold truncate size="lg">
                      {user.full_name}
                    </Text>
                  </Box>
                </Box>
              </div>
            </Box>
            <Box display="flex" justifyContent="end" alignSelf="end">
              <Button color={'red'} inline onClick={showSignupModalWrapper} text={followText} />
            </Box>
          </Box>
        </Container>
      </ContentHeader>
    );
  }
}

export default FixedHeader;
